import { useState, useCallback, useEffect, useRef } from "react";
import { Layer, Stage } from "react-konva";
import SeatPopup from "./SeatPopup";
import { Section } from "./Section";
import { useImportScheme } from "./useImportScheme";
import { LoadScreenMin } from "../UI/LoadScreenMin";
import { Button, ButtonGroup } from "react-bootstrap";

export const PayScheme = ({
    data,
    setCursorPos,
    basket,
    setBasket,
    deleteSeatData,
    setDeleteSeatData,
    schemeSize,
    setSchemeSize,
    selLng,
    categoriesSeat
    // sessionDetails
}) => {
    const { setUrl, schemeData, setSchemeData } = useImportScheme();
    const stageRef = useRef()
    const containerRef = useRef()
    const [scale, setScale] = useState(1);
    const [scaleToFit, setScaleToFit] = useState(5);
    const [popup, setPopup] = useState({ seat: null, row: null });
    const [selectedSeatsIds, setSelectedSeatsIds] = useState([]);
    const [heightBox, setHeightBox] = useState(500)
    const [virtualWidth, setVirtualWidth] = useState(1000);
    const [virtualHeight, setVirtualHeight] = useState(1000);
    const [oldWidth, setOldWidth] = useState(0)
    const [size, setSize] = useState({
        width: 0,
        height: 0,
        virtualWidth: 0
    });
    useEffect(() => {
        const newSize = {
            width: containerRef.current.offsetWidth,
            height: containerRef.current.offsetHeight
        };
        if (newSize.width !== size.width || newSize.height !== size.height) {
            setSize(newSize);
        }
    });
    const toggleScale = useCallback(() => {
        if (scale === 1) {
            setScale(scaleToFit);
        } else {
            setScale(1);
        }
    }, [scale, scaleToFit]);

    useEffect(() => {
        if (data) {
            setSchemeData(data)
        }
        else {
            setUrl("/seats-data-2.json")
        }
    }, [data])


    const setSizeScheme = () => {
        if (!stageRef.current) {
            return;
        }
        // console.log(size)
        const stage = stageRef.current;
        const clientRect = stage.getClientRect({ skipTransform: true });
        const clientRectTranform = stage.getClientRect();
        const scaleToFit = size.width / clientRect.width / 1.1;
        setHeightBox(clientRectTranform.height * 1.1)
        setScale(scaleToFit);
        setScaleToFit(scaleToFit);
        setVirtualWidth(clientRect.width);
        setVirtualHeight(clientRect.height);
        const newSize = {
            width: containerRef.current.offsetWidth,
            height: containerRef.current.offsetHeight
        };
        if (newSize.width !== size.width || newSize.height !== size.height) {
            setSize(newSize);
        }
        if (clientRect.height > 0) {
            setSchemeSize(containerRef.current.clientHeight)
        }
    }

    useEffect(() => {
        setSizeScheme()
    }, [schemeData, size]);

    useEffect(() => {
        const resizeHandeler = () => {
            setSizeScheme()
        }

        window.addEventListener('resize', resizeHandeler)
        return function () {
            window.addEventListener('resize', resizeHandeler)
        }
    }, [])

    const handleHover = useCallback((seat, pos, row, price, category, categoryFill, groupTag) => {
        if (groupTag) {
            price = 0
            data.sections[0].seatsByRows.forEach(rows =>
                rows.seats.filter(seat => seat.groupTag === groupTag).forEach(seat => {
                    price = price + seat.price
                })
            );
            // newAddIds = selectedSeatsIds.concat(newAddIds)
            // setSelectedSeatsIds(newAddIds);
            // return;
        }
        setPopup({
            seat: seat,
            row: row,
            position: pos,
            price: price,
            category: category,
            categoryFill: categoryFill,
            groupTag: groupTag
        });
    }, []);

    const handleCursor = useCallback((pos) => {
        // setCursorPos(pos)
    })
    const handleSelect = useCallback((seatId, groupTag, seatData) => {
        if (groupTag) {
            var newAddIds = []
            var newAddSeats = []
            data.sections[0].seatsByRows.forEach(rows =>
                rows.seats.filter(seat => seat.groupTag === groupTag).forEach(seat => {
                    newAddIds = newAddIds.concat([seat.id])
                    newAddSeats = newAddSeats.concat([seat])
                })
            );
            newAddIds = selectedSeatsIds.concat(newAddIds)
            newAddSeats = basket.concat(newAddSeats)
            setSelectedSeatsIds(newAddIds);
            setBasket(newAddSeats)
            return;
        }
        const newIds = selectedSeatsIds.concat([seatId]);
        // const seat = data.sections[0].seatsByRows.forEach(rows =>
        //     rows.seats.filter(seat => seat.groupTag === groupTag).forEach(seat => {
        //     })
        // );
        const seat = basket.concat([seatData])

        setSelectedSeatsIds(newIds);
        setBasket(seat)

    },
        [selectedSeatsIds]
    );
    const handleDeselect = useCallback(
        (seatId, groupTag) => {
            if (groupTag) {
                var newAddIds = []
                var newAddSeats = []

                data.sections[0].seatsByRows.forEach(rows =>
                    rows.seats.filter(seat => seat.groupTag === groupTag).forEach(seat => {
                        newAddIds = newAddIds.concat([seat.id])
                        newAddSeats = newAddSeats.concat([seat])
                    })
                );
                const ids = selectedSeatsIds.slice();
                const basketSlice = basket.slice();
                newAddIds.forEach(item => {
                    ids.splice(ids.indexOf(item), 1)
                })
                newAddSeats.forEach(seat => {
                    const itemsIndex = basket.map(item => item.id).indexOf(seat.id)
                    basketSlice.splice(basketSlice.indexOf(itemsIndex), 1)
                })
                setSelectedSeatsIds(ids);
                setBasket(basketSlice)
                return;
            }
            const ids = selectedSeatsIds.slice();
            const indexItem = basket.map(item => item.id).indexOf(seatId)
            const basketSlice = basket.slice();
            // console.log(basket.indexOf(indexItem))
            basketSlice.splice(indexItem, 1)
            ids.splice(ids.indexOf(seatId), 1);
            setBasket(basketSlice)
            setSelectedSeatsIds(ids);
        },
        [selectedSeatsIds]
    );
    useEffect(() => {
        if (deleteSeatData) {
            handleDeselect(deleteSeatData.id, deleteSeatData.groupTag)
            setDeleteSeatData(null)
        }
    }, [deleteSeatData])

    if (schemeData === null) {
        return <LoadScreenMin refcontanet={containerRef} height={20} />;
    }

    return (
        <div style={{
            position: "relative",
            backgroundColor: "#f3f3f3",
            width: "100%",
            height: heightBox,
        }}
            ref={containerRef}
            id={"schemeHellcontainer"}
        >
            <div className="ps-1 pt-1 position-absolute" style={{ left: 0, right: 0, zIndex: 100, width: 'fit-content' }}>
                <ButtonGroup>
                    <Button size="sm" className="btn-lc" onClick={() => {
                        setScale(scale + 0.10)
                        // setSizeScheme()
                    }
                    }>+</Button>
                    <Button size="sm" className="btn-lc" onClick={() => { setScale(scale - 0.10) }}>-</Button>
                </ButtonGroup>
            </div>
            <Stage

                ref={stageRef}
                width={size.width}
                height={size.height}
                draggable
                // x={size.width}
                x={0}
                // y={200}
                dragBoundFunc={pos => {
                    // console.log(pos)
                    pos.x = Math.min(
                        size.width / 2,
                        Math.max(pos.x, -virtualWidth * scale + size.width / 1.25)
                    );
                    pos.y = Math.min(
                        size.height / 1.25,
                        Math.max(pos.y, -virtualHeight * scale + size.height / 1.25)
                    );
                    return pos;
                }}
                // onDblTap={toggleScale}
                // onDblClick={toggleScale}
                scaleX={scale}
                scaleY={scale}
            >
                <Layer>

                    {schemeData.sections.map(section => {
                        const offset = 30;
                        return (
                            <Section
                                handleCursor={handleCursor}
                                x={offset}
                                y={schemeData.offsetTop}
                                width={schemeData.width}
                                height={schemeData.height}
                                texts={schemeData.texts}
                                objects={schemeData.staticObjects}
                                key={section.id}
                                section={section.seatsByRows}
                                staticObjects={section.staticObjects}
                                selectedSeatsIds={selectedSeatsIds}
                                onHoverSeat={handleHover}
                                onSelectSeat={handleSelect}
                                onDeselectSeat={handleDeselect}
                            />
                        );
                    })}
                </Layer>
            </Stage>
            {popup.seat && (
                <SeatPopup
                    position={popup.position}
                    seatId={popup.seat}
                    nameRow={popup.row}
                    price={popup.price}
                    category={popup.category}
                    categoryFill={popup.categoryFill}
                    groupTag={popup.groupTag}
                    selLng={selLng}
                    onClose={() => {
                        setPopup({ seat: null });
                    }}
                />
            )}
        </div>
    )
}

